import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbTrail = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeMap = {
    '/live-dashboard': { label: 'Dashboard', parent: null },
    '/live-search-results': { label: 'Search Results', parent: null },
    '/mentions-feed': { label: 'Mentions Feed', parent: null },
    '/mention-detail': { label: 'Mention Detail', parent: '/mentions-feed' },
    '/persona-intelligence': { label: 'Persona Intelligence', parent: null },
    '/predictive-trends': { label: 'Predictive Trends', parent: null }
  };

  const buildBreadcrumbs = () => {
    const breadcrumbs = [];
    const currentRoute = routeMap?.[location?.pathname];

    if (!currentRoute) return breadcrumbs;

    if (currentRoute?.parent) {
      const parentRoute = routeMap?.[currentRoute?.parent];
      breadcrumbs?.push({
        label: parentRoute?.label,
        path: currentRoute?.parent,
        isActive: false
      });
    }

    breadcrumbs?.push({
      label: currentRoute?.label,
      path: location?.pathname,
      isActive: true
    });

    return breadcrumbs;
  };

  const breadcrumbs = buildBreadcrumbs();

  if (breadcrumbs?.length === 0) return null;

  const handleNavigation = (path) => {
    if (path !== location?.pathname) {
      navigate(path);
    }
  };

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb navigation">
      <div className="breadcrumb-item">
        <button
          className="breadcrumb-link flex items-center gap-1"
          onClick={() => navigate('/live-dashboard')}
          aria-label="Navigate to home"
        >
          <Icon name="Home" size={16} />
        </button>
      </div>
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path}>
          <div className="breadcrumb-separator">
            <Icon name="ChevronRight" size={16} />
          </div>
          <div className="breadcrumb-item">
            {crumb?.isActive ? (
              <span className="breadcrumb-current" aria-current="page">
                {crumb?.label}
              </span>
            ) : (
              <button
                className="breadcrumb-link"
                onClick={() => handleNavigation(crumb?.path)}
                aria-label={`Navigate to ${crumb?.label}`}
              >
                {crumb?.label}
              </button>
            )}
          </div>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default BreadcrumbTrail;